import { Component, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Labels } from 'src/app/dictionaries/labels';

@Component({
    selector: 'app-client-matter-data-info',
    templateUrl: './client-matter-data-info.component.html',
    styleUrls: ['./client-matter-data-info.component.scss'],
    standalone: false
})
export class ClientMatterDataInfoComponent {
  @Input() patient: any;
  @Input() currentFolderName: string = '';
  @Input() currentFolder: string = '';
  @Input() filesTableDataSource: any;
  @Input() accordionFolders: any[] = [];
  Labels = Labels;
  plancode: any;
  constructor(private auth_$: AuthService) {
    this.auth_$.userData.subscribe(user => (this.plancode = user['plancode']));
  }

  get displayFolderName(): string {
    // First, try to find the expanded folder from accordion
    if (this.accordionFolders && this.accordionFolders.length > 0) {
      const expandedFolder = this.accordionFolders.find(folder => folder.expanded === true);
      if (expandedFolder && expandedFolder.name && expandedFolder.name !== 'INDEX') {
        return expandedFolder.name;
      }
    }

    // Fallback: Try currentFolderName if properly set
    if (this.currentFolderName && this.currentFolderName.trim() !== '' && this.currentFolderName !== 'INDEX') {
      return this.currentFolderName;
    }

    // Try to get folder name from the first file in the table
    if (this.filesTableDataSource && this.filesTableDataSource.data && this.filesTableDataSource.data.length > 0) {
      const firstFile = this.filesTableDataSource.data[0];
      if (firstFile.parentFolderName && firstFile.parentFolderName !== 'INDEX') {
        return firstFile.parentFolderName;
      }
    }

    // Last resort: Use currentFolder ID if available
    if (this.currentFolder && this.currentFolder !== '' && this.currentFolder !== 'all') {
      return this.currentFolder;
    }

    return '';
  }
}
